import { Image } from "capitalrx-components-2.0/lib/general";
import { Shelf } from "capitalrx-components-2.0/lib/layout";
import { Body } from "capitalrx-components-2.0/lib/typography";

import CapRxLogo from "@/static/images/caprx-logo.svg?url";

import styles from "./WhiteLabelNavbar.module.scss";

export const Navbar = () => {
  return (
    <Shelf className={styles.WhiteLabelNavbar}>
      <div role="img" aria-label="client logo" className={styles["LogoImage"]} />
      <Shelf.Spacer />
      <Body className={styles.WhiteLabelNavbarText}>Powered by <Image src={CapRxLogo} alt="Capital Rx Logo" /></Body>
    </Shelf>
  );
};
